/**
 * Códigos de erro estáveis do backend — espelham
 * `com.bolao.adapters.web.exception.ErrorCodes` da API.
 *
 * Chegam no campo `code` do corpo de erro (`err.response.data.code`).
 * A UI deve rotear por estes códigos, nunca pelo texto da `message` — que é
 * traduzível (PT-BR/EN/ES) e portanto instável.
 */
export const ErrorCodes = {
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
  EMAIL_ALREADY_REGISTERED: 'EMAIL_ALREADY_REGISTERED',
  CPF_INVALID: 'CPF_INVALID',
  CPF_ALREADY_REGISTERED: 'CPF_ALREADY_REGISTERED',
  // Bolão (Pool)
  ALREADY_POOL_MEMBER: 'ALREADY_POOL_MEMBER',
  POOL_NOT_FOUND: 'POOL_NOT_FOUND',
  POOL_NOT_PUBLIC: 'POOL_NOT_PUBLIC',
  NOT_POOL_MEMBER: 'NOT_POOL_MEMBER',
  POOL_CREATOR_CANT_LEAVE: 'POOL_CREATOR_CANT_LEAVE',
  POOL_NAME_EMPTY: 'POOL_NAME_EMPTY',
  /** Apenas criador do bolão ou admin global pode remover membros. */
  POOL_REMOVE_NOT_AUTHORIZED: 'POOL_REMOVE_NOT_AUTHORIZED',
  /** Criador do bolão não pode ser removido (UX direciona pra excluir o bolão). */
  CANT_REMOVE_POOL_CREATOR: 'CANT_REMOVE_POOL_CREATOR',
  /** Usuário gratuito atingiu o limite de bolões privados que pode participar como convidado. */
  FREE_PARTICIPATION_LIMIT: 'FREE_PARTICIPATION_LIMIT',
  /** Bolão privado atingiu o limite de membros (criador não é Premium). */
  POOL_MEMBER_LIMIT: 'POOL_MEMBER_LIMIT',
  // Assinatura Premium
  SUBSCRIPTION_PLAN_UNAVAILABLE: 'SUBSCRIPTION_PLAN_UNAVAILABLE',
  SUBSCRIPTION_ALREADY_ACTIVE: 'SUBSCRIPTION_ALREADY_ACTIVE',
  SUBSCRIPTION_NOT_FOUND: 'SUBSCRIPTION_NOT_FOUND',
  SUBSCRIPTION_MANAGED_BY_GOOGLE_PLAY: 'SUBSCRIPTION_MANAGED_BY_GOOGLE_PLAY',
  SUBSCRIPTION_MANAGED_BY_STRIPE: 'SUBSCRIPTION_MANAGED_BY_STRIPE',
  ASAAS_BR_ONLY: 'ASAAS_BR_ONLY',
  STRIPE_DISABLED: 'STRIPE_DISABLED',
  PRICE_UNAVAILABLE_REGION: 'PRICE_UNAVAILABLE_REGION',
  // Usuário (edição de dados)
  EMAIL_BUSY: 'EMAIL_BUSY',
  CPF_BUSY: 'CPF_BUSY',
  // Cupom Premium
  COUPON_NOT_FOUND: 'COUPON_NOT_FOUND',
  COUPON_INACTIVE: 'COUPON_INACTIVE',
  COUPON_EXPIRED: 'COUPON_EXPIRED',
  COUPON_EXHAUSTED: 'COUPON_EXHAUSTED',
  COUPON_CODE_DUPLICATE: 'COUPON_CODE_DUPLICATE',
} as const;

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];

/**
 * Extrai o `code` de um erro. Funciona tanto para erros Axios crus
 * (`err.response.data.code`) quanto para erros re-lançados pelo AuthContext,
 * que reanexam o código em `err.code`.
 */
export function extractErrorCode(err: unknown): string | undefined {
  const e = err as { response?: { data?: { code?: string } }; code?: string };
  return e?.response?.data?.code ?? e?.code;
}
